// extracted by mini-css-extract-plugin
module.exports = {"primary":"#043d5d","selected":"#819eae","secondary":"#707071","primary25":"\"#fff\"","primary50":"#fff","gray":"#f6f8fa","bodyGray":"#fff"};